var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.itemClassName},[_c('div',{class:_vm.prefixCls + '-item-tail'}),_vm._v(" "),_c('div',{class:_vm.dotClassName,style:({ borderColor: ['blue','red','green'].includes(_vm.color) ? null : _vm.color })},[_vm._t("dot")],2),_vm._v(" "),_c('div',{staticClass:"ant-timeline-item-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-479bdd93","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./vb/components/timeline/timeline-item.vue
// module id = null
// module chunks = 